export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const quarters = ["1st", "2nd", "3rd", "4th"];

export const leaveTypes = [
  { value: "1", label: "Earned Leave (EL)" },
  { value: "2", label: "Compensatory Off (Comp-off)" },
  { value: "3", label: "Loss Of Pay (LOP)" },
  { value: "4", label: "Maternity Leave" },
  { value: "5", label: "Paternity Leave" },
];

export const leaveTypes2 = [
  { value: "1", label: "Earned Leave (EL)" },
  { value: "2", label: "Working days for Compoff" },
  { value: "3", label: "Compensatory Off (Comp-off)" },
  { value: "4", label: "Loss Of Pay (LOP)" },
  { value: "5", label: "Maternity Leave" },
  { value: "6", label: "Paternity Leave" },
];

export const leaveTypes3 = [
  { value: "1", label: "Leaves Balance" },
  { value: "2", label: "0 Leave Balance" },
  { value: "3", label: "Comp off" },
  { value: "4", label: "Worked during holiday" },
  { value: "5", label: "Loss of pay" },
  { value: "6", label: "Earned leaves taken" },
  { value: "7", label: "Total leaves taken (Including LOP)" },
  { value: "8", label: "On Maternity Leave" },
  { value: "9", label: "On Paternity Leave" },
  { value: "10", label: "Sick Leave (SL)" },
  { value: "11", label: "Casual Leave (CL)" },
  { value: "12", label: "Bereavement Leave (BL)" },
  { value: "13", label: "Marriage Leave" },
];

export const leaveDuration = [
  { value: "1", label: "1 Day" },
  { value: "2", label: "2 DAYS" },
  { value: "3", label: "3 DAYS" },
  { value: "4", label: "4 DAYS" },
];

export const leaveStatus = [
  { value: "0", label: "Pending" },
  { value: "1", label: "Rejected" },
  { value: "2", label: "Approved" },
];

export const locations = [
  { value: "1", label: "Mumbai" },
  { value: "2", label: "Pune" },
  { value: "3", label: "Gujarat" },
  { value: "4", label: "Indore" },
  { value: "5", label: "USA" },
  { value: "6", label: "Canada" },
  { value: "7", label: "Bahrain" },
];

export const department = [
  { value: "1", label: "Development" },
  { value: "2", label: "ID" },
  { value: "3", label: "Articulate" },
  { value: "4", label: "Animator" },
  { value: "5", label: "Accounts" },
  { value: "6", label: "HR" },
];

export const leaveCategory = [
  { value: "1", label: "Sick Leave (SL)" },
  { value: "2", label: "Casual Leave (CL)" },
  { value: "3", label: "Bereavement Leave (BL)" },
  { value: "4", label: "Marriage Leave" },
];

export const leaveSessions = [
  { value: "0", label: "Full Day" },
  { value: "1", label: "Half Day" },
];

export const compOffHours = [
  { value: "3", label: "3 Hours" },
  { value: "5", label: "5 Hours" },
  { value: "7", label: "7 Hours" },
];

export const Checkbox = () => {
  return (
    <label className="checkbox-container">
      <input type="checkbox" />
      <span className="checkmark"></span>
    </label>
  );
};

export const leaveDays = [
  { value: "1", label: "1 Day" },
  { value: "2", label: "2 Days" },
  { value: "3", label: "3 Days" },
  { value: "4", label: "4 Days" },
  { value: "5", label: "5 Days" },
  { value: "6", label: "6 Days" },
  { value: "7", label: "7 Days" },
  { value: "8", label: "8 Days" },
  { value: "9", label: "9 Days" },
  { value: "10", label: "10 Days" },
  { value: "11", label: "11 Days" },
  { value: "12", label: "12 Days" },
  { value: "13", label: "13 Days" },
  { value: "14", label: "14 Days" },
  { value: "15", label: "15 Days" },
  { value: "16", label: "16 Days" },
  { value: "17", label: "17 Days" },
  { value: "18", label: "18 Days" },
  { value: "19", label: "19 Days" },
  { value: "20", label: "20 Days" },
  { value: "21", label: "21 Days" },
  { value: "22", label: "22 Days" },
  { value: "23", label: "23 Days" },
  { value: "24", label: "24 Days" },
  { value: "25", label: "25 Days" },
  { value: "26", label: "26 Days" },
  { value: "27", label: "27 Days" },
  { value: "28", label: "28 Days" },
  { value: "29", label: "29 Days" },
  { value: "30", label: "30 Days" },
];

export const days = [
  { value: 1, label: "1st" },
  { value: 2, label: "2nd" },
  { value: 3, label: "3rd" },
  { value: 4, label: "4th" },
  { value: 5, label: "5th" },
  { value: 6, label: "6th" },
  { value: 7, label: "7th" },
  { value: 8, label: "8th" },
  { value: 9, label: "9th" },
  { value: 10, label: "10th" },
  { value: 11, label: "11th" },
  { value: 12, label: "12th" },
  { value: 13, label: "13th" },
  { value: 14, label: "14th" },
  { value: 15, label: "15th" },
  { value: 16, label: "16th" },
  { value: 17, label: "17th" },
  { value: 18, label: "18th" },
  { value: 19, label: "19th" },
  { value: 20, label: "20th" },
  { value: 21, label: "21st" },
  { value: 22, label: "22nd" },
  { value: 23, label: "23rd" },
  { value: 24, label: "24th" },
  { value: 25, label: "25th" },
  { value: 26, label: "26th" },
  { value: 27, label: "27th" },
  { value: 28, label: "28th" },
  { value: 29, label: "29th" },
  { value: 30, label: "30th" },
  { value: 31, label: "31st" },
];

export const hours = [
  { value: 0, label: "00" },
  { value: 1, label: "01" },
  { value: 2, label: "02" },
  { value: 3, label: "03" },
  { value: 4, label: "04" },
  { value: 5, label: "05" },
  { value: 6, label: "06" },
  { value: 7, label: "07" },
  { value: 8, label: "08" },
  { value: 9, label: "09" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 13, label: "13" },
  { value: 14, label: "14" },
  { value: 15, label: "15" },
  { value: 16, label: "16" },
  { value: 17, label: "17" },
  { value: 18, label: "18" },
  { value: 19, label: "19" },
  { value: 20, label: "20" },
  { value: 21, label: "21" },
  { value: 22, label: "22" },
  { value: 23, label: "23" },
];

export const minutes = [
  { value: 0, label: "00" },
  { value: 1, label: "01" },
  { value: 2, label: "02" },
  { value: 3, label: "03" },
  { value: 4, label: "04" },
  { value: 5, label: "05" },
  { value: 6, label: "06" },
  { value: 7, label: "07" },
  { value: 8, label: "08" },
  { value: 9, label: "09" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 13, label: "13" },
  { value: 14, label: "14" },
  { value: 15, label: "15" },
  { value: 16, label: "16" },
  { value: 17, label: "17" },
  { value: 18, label: "18" },
  { value: 19, label: "19" },
  { value: 20, label: "20" },
  { value: 21, label: "21" },
  { value: 22, label: "22" },
  { value: 23, label: "23" },
  { value: 24, label: "24" },
  { value: 25, label: "25" },
  { value: 26, label: "26" },
  { value: 27, label: "27" },
  { value: 28, label: "28" },
  { value: 29, label: "29" },
  { value: 30, label: "30" },
  { value: 31, label: "31" },
  { value: 32, label: "32" },
  { value: 33, label: "33" },
  { value: 34, label: "34" },
  { value: 35, label: "35" },
  { value: 36, label: "36" },
  { value: 37, label: "37" },
  { value: 38, label: "38" },
  { value: 39, label: "39" },
  { value: 40, label: "40" },
  { value: 41, label: "41" },
  { value: 42, label: "42" },
  { value: 43, label: "43" },
  { value: 44, label: "44" },
  { value: 45, label: "45" },
  { value: 46, label: "46" },
  { value: 47, label: "47" },
  { value: 48, label: "48" },
  { value: 49, label: "49" },
  { value: 50, label: "50" },
  { value: 51, label: "51" },
  { value: 52, label: "52" },
  { value: 53, label: "53" },
  { value: 54, label: "54" },
  { value: 55, label: "55" },
  { value: 56, label: "56" },
  { value: 57, label: "57" },
  { value: 58, label: "58" },
  { value: 59, label: "59" },
];

export const workHours = [
  { value: "1", label: "1 Hours" },
  { value: "2", label: "2 Hours" },
  { value: "3", label: "3 Hours" },
  { value: "4", label: "4 Hours" },
  { value: "5", label: "5 Hours" },
  { value: "6", label: "6 Hours" },
  { value: "7", label: "7 Hours" },
  { value: "8", label: "8 Hours" },
  { value: "9", label: "9 Hours" },
  { value: "10", label: "10 Hours" },
  { value: "11", label: "11 Hours" },
  { value: "12", label: "12 Hours" },
];

export const ArrowLeft = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9419 3.30806C13.186 3.55214 13.186 3.94786 12.9419 4.19194L7.13388 10L12.9419 15.8081C13.186 16.0521 13.186 16.4479 12.9419 16.6919C12.6979 16.936 12.3021 16.936 12.0581 16.6919L5.80806 10.4419C5.56398 10.1979 5.56398 9.80214 5.80806 9.55806L12.0581 3.30806C12.3021 3.06398 12.6979 3.06398 12.9419 3.30806Z"
    />
  </svg>
);

export const ArrowRight = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.05806 3.30806C7.30214 3.06398 7.69786 3.06398 7.94194 3.30806L14.1919 9.55806C14.436 9.80214 14.436 10.1979 14.1919 10.4419L7.94194 16.6919C7.69786 16.936 7.30214 16.936 7.05806 16.6919C6.81398 16.4479 6.81398 16.0521 7.05806 15.8081L12.8661 10L7.05806 4.19194C6.81398 3.94786 6.81398 3.55214 7.05806 3.30806Z"
    />
  </svg>
);

export const leaveBals = [
  { value: 0, label: "00" },
  { value: 1, label: "01" },
  { value: 2, label: "02" },
  { value: 3, label: "03" },
  { value: 4, label: "04" },
  { value: 5, label: "05" },
  { value: 6, label: "06" },
  { value: 7, label: "07" },
  { value: 8, label: "08" },
  { value: 9, label: "09" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 13, label: "13" },
  { value: 14, label: "14" },
  { value: 15, label: "15" },
  { value: 16, label: "16" },
  { value: 17, label: "17" },
  { value: 18, label: "18" },
  { value: 19, label: "19" },
  { value: 20, label: "20" },
  { value: 21, label: "21" },
  { value: 22, label: "22" },
  { value: 23, label: "23" },
];

export const empListDemo = [
  { name: "Cameron Williamson", desig: "Front-End Developer" },
  { name: "Jenny Wilson", desig: "Development Team Lead" },
  { name: "Guy Hawkins", desig: "Back-End Developer" },
  { name: "Esther Howard", desig: "PHP Developer" },
  { name: "Bessie Cooper", desig: "Front-End Developer" },
  { name: "Darlene Robertson", desig: "Media Team Lead" },
  { name: "Albert Flores", desig: "Animator" },
  { name: "Cody Fisher", desig: "Jr. ID" },
  { name: "Bessie Cooper", desig: "Front-End Developer" },
];

export const designations = [
  {
    value: "1",
    label: "HR",
  },
  {
    value: "2",
    label: "System Administator",
  },
  {
    value: "3",
    label: "Dot Net Developer",
  },
  {
    value: "4",
    label: "Frontend Developer",
  },
  {
    value: "5",
    label: "PHP",
  },
  {
    value: "6",
    label: "Android Developer",
  },
  {
    value: "7",
    label: "Animator",
  },
  {
    value: "8",
    label: "Full Stack Engineer",
  },
  {
    value: "9",
    label: "Articulate Storyline Developer",
  },
  {
    value: "10",
    label: "Mobile App Developer",
  },
  {
    value: "11",
    label: "Sr.ID",
  },
];

export const empTableColumns = [
  { value: "1", label: "ID" },
  { value: "2", label: "Name" },
  { value: "3", label: "Designation" },
  { value: "4", label: "Type" },
  { value: "5", label: "Gender" },
  { value: "6", label: "Reporting Manager" },
  { value: "7", label: "Department" },
  { value: "8", label: "Leave Type" },
  { value: "9", label: "Location" },
];
